import { Observable } from 'rxjs';
// import { SstModules, SstSystems } from '../../rule-builder/models/models';
// import { SelectItemLanguageResource } from '../../form-builder/models/models';
import { SelectItemLanguageResource } from '../../form-builder/models/models';
import { SstSystems, SstModules } from '../../rule-builder/models/models';

export enum Status {
  Failed = 0,
  Success = 1,
  Redirect = 2,
  SamePageRedirection = 3,
  ShowSuccessMessage = 4,
  InvalidStep = 5,
  PaymentReached = 6
}

export enum DefaultDates {
  Today = 1,
  Tomorrow = 2

}


export class ResponseResult<T> {
  data: T;
  errors: string[];
  status: Status;
  forms: T;
}

export class SearchResult<T> {
  result: Array<T>;
  totalRows: number;
}

export class LoginInfoView {
  companyName: string;
  branchName: string;
  companies: any[];
  branches: any[];
}

export interface IService<T> {
  GetById(Id: number): Observable<ResponseResult<T>>;
  Post(entity: T): Observable<ResponseResult<T>>;
  Put(entity: T): Observable<ResponseResult<T>>;
  Delete(Id: number): Observable<ResponseResult<T>>;
}

// export interface IContainers{
//    id: number;
//    key: string;
//    type?: number;
//    name: string;
//    name2: string;
//    order?: number;
//    componentId?: number;
//    refContainerId?: number;
//    notes: string;
//    creationUser: string;
//    creationDate: Date;
//    modificationUser: string;
//    modificationDate?: Date;
//   //  refContainer: IContainers;
//   //  inverseRefContainer: Array<IContainers>;
//   //  sstFormControls: Array<IFormControls>;
// }


// export interface IFormControls {
//    id: number;
//     key: string;
//     type?: number;
//     name: string;
//     name2: string;
//     order?: number;
//    value?: string;
//     controlValue?: number;
//     controlOrder?: number;
//     icon: string;
//     width?: number;
//     required: number;
//     disabled: number;
//     hasSubformControls?: number;
//     containerId?: number;
//     refControlId?: number;
//     notes: string;
//     creationUser: string;
//     creationDate: Date;
//     modificationUser: string;
//     modificationDate?: Date;
//     options?: string;
//     // container: IContainers;
//     // refControl: IFormControls;
//     // inverseRefControl: Array<IFormControls>;

// }


export enum Application {
  GeneralInsurance = 8,
  MedicalInsurance = 10,
  LifeInsurance = 27,
  Greeting = 4,
  Schedular = 306,
  iCore3 = 32,
  SharedSetup = 5,
  SharedComponent = 28
}

export enum DomainId {
  Languages = 3144,
  Actions = 5,
  MathematicalOperators = 4076,
  LogicalOperators = 4077,
  RelationalOperators = 4078,
  TrigonometricFunctions = 4079,
  MathematicalFunctions = 4050,
  HttpRequestTypes = 4081,
  ApiTypes = 4082,
  Systems = 4083,
  Modules = 4084,
  Authentication = 4085,
  RequestElementModule = 4086,
  ResponseElementModule = 4094,
  DatabaseTypes = 4087,
  SourceTypes = 4088,
  DateSource = 308,
  DDL = 309,
  Session = 311,
  MappingType = 401,
  ParameterType = 402,
  RunTimeVariable = 407,
  OperatorType = 4122,
  MappingFieldSetup = 4086,
  StringFunctions = 11,
  AggregateFunctions = 12
}

export class SstEpaymentMethods {
  public id: number;
  public name: string;
  public name2: string;
  public notes: string;
  public systemId: number;
  public companyId: number;
  public creationUser: string;
  public creationDate: Date;
  public modificationUser?: string;
  public modificationDate?: Date;
}

export class SstPaymentDetails {
  public id: number;
  public currency: string;
  public merchantId: string;
  public apiId: string;
  public transactionId: string;
  public transactionPassword: string;
  public authenticationType: number;
  public paymentId: number;
  public creationUser: string;
  public creationDate: Date;
  public modificationUser?: string;
  public modificationDate?: Date;

}

export class loginInfo {
  userName: string;
  password: string;
  companyId: number;
  branchId: number;
  languageId: number;
  companyName?: string;
  branchName?: string;
}

export class Country {
  name: string;
  code: string;
}


export class SstUsers {
  public id: number;
  public name: string;
  public name2?: string;
  public username: string;
  public email: string;
  public country: string;
  public city: number;
  public address: string;
  public department: number;
  public occupation: number;
  public image: string;
  public imgStyle?: string;
  public companyId: number;
  public birthDate: Date;
  public phoneNo: number;
  public mobileNo: number;
  public poBox: number;
  public zipCode: number;
  public creationUser: string;
  public creationDate: Date;
  public modificationUser?: string;
  public modificationDate?: Date;
}

export class SstAlerts {

}

export class SStUserAlert {
  public id: number;
  public AlertId: number;
  public UserId: number;
  public ReadFlag: number;
  public ReadDate: Date;
  public SystemId: number;
  public Alert: SstAlerts;
  public sstUser: SstUsers;
  public creationUser: string;
  public creationDate: Date;
  public modificationUser: string;
  public modificationDate?: Date;
}

export class User {
  companyId: number;
  userName: string;
  branchId: number;
  language: number;
  companyName?: string;
  branchName?: string;
}

export class MenuItem {
  Id: Number;
  label: string;
  AlternativeName: string;
  Url: string;
  icon: string;
  Application: Application;
  routerLink: string;
  items: MenuItem[];
}


export enum MenuType {
  Application = 1,
  Module = 2,
  SubModule = 3,
  Pages = 4
}

export class DataMenus {

  isError: boolean;
  error: string;
  errorCode: string;
  aPIVersion: string;
  data: SystemMenus[];

}

export class GenerateApplicationMenuDTO {
  lstApplications: number[] = [];
  cRG_COM_ID: number
  uSERNAME: string
}


export class SystemMenus {
  cAM_APP_ID: number;
  CAM_FRM_CL_ID: number;
  cAM_FRM_CODE: string;
  cAM_MOD_CODE: string;
  cAM_SMU_ID: number;
  cAM_SYS_CODE: string;
  cRG_COM_ID: number;
  hELP_PAGE_URL: string;
  iD: number;
  mENU_ORDER: number;
  mENU_TYPE: number;
  nAME: string;
  nAME2: string;
  uRL: string;
  sHOW_IN_MENU: number;
}

export class Authorized {
  data: boolean;
  isError: boolean;
  errorCode: string;
  aPIVersion: string;
  error: string;
}

export class MajorCode {
  iD: number;
  nAME: string;
  nAME2: string;

}

export class MinorCode {
  iD: Number;
  nAME: string;
  nAME2: string;
}

export class SstDomains {
  public Id: number;
  public Code: number;
  public Name: string;
  public Name2: string;
  public DefaultValue: number;
  public SystemId: number;
  public ModuleCode: string;
  public CompanyId: number;
  public Notes: string;
  public SstDomainValues: Array<SstDomainValues>;
}

export class SstDomainValues {
  public Id: number;
  public Value: number;
  public Name: string;
  public Name2: string;
  public Order: number
  public DomainCode: number;
  public DomainId: number;
  public SystemId: number;
  public CompanyId: number;
  public CreationUser: string;
  public CreationDate: Date;
  public ModificationUser: string;
  public ModificationDate?: Date;
  public DomainCodeNavigation: SstDomains;
}

export class SstCodes {
  public Id: number;
  public MajorCode: number;
  public MinorCode: number;
  public Name: string;
  public Name2: string;
  public SystemId: number;
  public ModuleCode: string;
  public CodeId?: number;
  public DomainId?: number;
  public CompanyId: number;
  public Notes: string;
  public Code: SstCodes;
  public ModuleCodeNavigation: SstModules;
  public System: SstSystems;
  public InverseCode: Array<SstCodes>;
}

export class NotificationApprovalInput {
  public tokenId: number;
  public notificationId: number;
  public templateType: number;
  public username: string;
  public jsonObject: string;
}

/**
 * @description enum for Message Notifications
 * @createdBy AlaaKhazaleh
 */
export enum MessageType {
  Info = 1,
  Success = 2,
  Warn = 3,
  Error = 4,

}

export enum GridType {
  ThreeColumns = 1,
  FourColumns = 2
}


export class SerchQuotation {
  segmentCode: string;
  email: string;
  moduleID?: number;
  externalRef?: number;
  customerID?: string;
  nationaID?: string;
  passportNo?: string;
}
export class SerchQuotationInput {
  segmentCode: string;
  CustomerID?: number;
  LeadID?: number;
  culture: string;

}

export class SerchNBIInput {
  segmentCode: string;
  registrationNo: string;
  email: string;

}
export class SerchQuotationResponse {
  id: number;
  segmentCode: string;
  amount: number;
  stringamount: string
  producNameString: string
  productName: number;
  classId: number;
  quotationDate: Date;
  quotationDateString: string;
  policyType: number;
  insuranceProductType: number;
  isCalculated: string;
  allowUpdate: boolean;
  allowCopy: boolean;
  canBeUpdated: boolean;
  expiryDate: Date; // canBeUpdated isConverted
  expiryDateString: string;
  isConverted: boolean;
  requireApproval: number;


}

export interface DataRowModel {
  label: any;
  value: any;
  order: number;
  isChecked: boolean;
  languageResource: SelectItemLanguageResource[];
}

